<template>
    <section class="excuse-edit-view">
        <div class="modal-header">
            <h3>Add Excuse</h3>
            <p class="required-fields">All fields marked with * are required</p>
        </div>
        <app-form
            ref="excuseForm"
            :model="excuse"
            :rules="rules"
            @submit.native.prevent="submit">
            <app-form-item label="Date" prop="date">
                <app-date-picker
                    id="date"
                    v-model="excuse.date"
                    format="MM/dd/yyyy"
                    autofocus
                    title="The user can either key in date using format mm/dd/yyyy or use the calendar modal to select a date"/>
            </app-form-item>
            <app-form-item label="Course or Event" prop="attendable_id">
                <app-select
                    id="attendable_id"
                    v-model="excuse.attendable_id"
                    placeholder="Select">
                    <app-option-group
                        v-for="group in options"
                        :key="group.label"
                        :label="group.label">
                        <app-option
                            v-for="item in group.options"
                            :key="item.uuid"
                            :label="item.title"
                            :value="item.id"
                            @click.native="setExcuseType(group.label)" />
                    </app-option-group>
                </app-select>
            </app-form-item>
            <app-form-item label="Notes" prop="notes">
                <app-input id="notes" v-model="excuse.notes" type="textarea" />
            </app-form-item>

            <div class="modal-footer">
                <app-button
                    :loading="isSaving"
                    type="primary"
                    size="large"
                    native-type="submit">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import Excuse from '@/store/models/Excuse'

export default {
    name: 'excuse-edit-detail',
    components: {},
    inject: ['modalOptions'],
    props: [ 'student' ],
    data() {
        return {
            excuse: new Excuse,
            rules: {
                date: [
                    {
                        required: true,
                        message: 'Please enter a date',
                        trigger: 'blur'
                    }
                ],
                attendable_id: [
                    {
                        required: true,
                        message: 'Please select a course or event',
                        trigger: 'blur,change'
                    }
                ]
            },
            isSaving: false
        }
    },
    computed: {
        options() {
            return [
                {
                    label: 'Course',
                    options: this.student.courses
                },
                {
                    label: 'Event',
                    options: this.student.events
                }
            ]
        }
    },
    methods: {
        submit() {
            this.$refs['excuseForm'].validate(valid => {
                if (valid) {
                    this.isSaving = true
                    this.excuse.student_id = this.student.id
                    this.excuse.$create()
                        .then(() => {
                            this.isSaving = false
                            this.modalOptions.modalOpen = false
                        })

                    return false
                }
            })
        },
        setExcuseType(type) {
            this.excuse.attendable_type = type.toLowerCase()
        }
    }
}
</script>
